import React from 'react';
import PropTypes from 'prop-types';
import { noop } from 'Helpers/PropTypes';
import { MetaResourceRenderer } from 'Components/UI/Meta/MetaForm/Components/MetaResourceRenderer';
import {
  FacetPlanProposalScenarioSelectionIntroPageLayout,
} from 'Views/Page/Content/Templates/FacetPlanProposalScenarioSelectionIntroPageTemplate/Layout';


export default function FacetPlanProposalScenarioSelectionIntroPage({ resource, onAgentReview }) {
  return (
    <MetaResourceRenderer
      layout={FacetPlanProposalScenarioSelectionIntroPageLayout}
      resource={resource}
      LayoutProps={{
        onAgentReview,
      }}
    />
  );
}

FacetPlanProposalScenarioSelectionIntroPage.defaultProps = {
  onAgentReview: noop,
};

FacetPlanProposalScenarioSelectionIntroPage.propTypes = {
  resource: PropTypes.object.isRequired,
  onAgentReview: PropTypes.func,
};
